import { Validator, NG_VALIDATORS, AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { Directive, Input } from "@angular/core";
import { ratingValueValidator, emailValueValidator, emailConfirmationValidator, passwordValueValidator, customUserNameValidator, ValidatorsConfig } from "./validator.function";
import { CustomerInputFieldViewModel } from "../models";


@Directive({
  selector: "[appRatingValueValidator]",
  providers: [{ provide: NG_VALIDATORS, useExisting: RatingValueValidatorDirective, multi: true }]
})
export class RatingValueValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } | null {
    return ratingValueValidator()(control);
  }
}

@Directive({
  selector: "[appEmailValidator]",
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }]
})
export class EmailValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } | null {
    return emailValueValidator()(control);
  }
}

@Directive({
  selector: "[appEmailConfirmation]",
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailConfirmationDirective, multi: true }]
})
export class EmailConfirmationDirective implements Validator {
  @Input("appEmailConfirmation") private newPassword: string;
  validate(control: AbstractControl): { [key: string]: any } | null {
    return emailConfirmationValidator(this.newPassword)(control);
  }
}

@Directive({
  selector: "[appPasswordValidator]",
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true }]
})
export class PasswordValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } | null {
    return passwordValueValidator()(control);
  }
}

@Directive({
  selector: "[customUserNameValidator]",
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomUserNameValidatorDirective, multi: true }]
})
export class CustomUserNameValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } | null {
    return customUserNameValidator()(control);
  }
}

@Directive({
  selector: '[dynamicFieldValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DynamicFieldValidatorDirective, multi: true }]
})

export class DynamicFieldValidatorDirective implements Validator {
  @Input('dynamicFieldValidator') CustomerInputFieldViewModel: CustomerInputFieldViewModel;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.CustomerInputFieldViewModel) return null;
    const validators = ValidatorsConfig.getValidatorsForDynamicFields(this.CustomerInputFieldViewModel);
    const composed = Validators.compose(validators);
    return composed ? composed(control) : null;
  }
}